import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-16 bg-background-50">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2
              className="text-2xl md:text-3xl font-bold text-foreground-950"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              最新动态
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">掌握佐佐木希最新资讯</p>
          </div>
          <Link
            to="/category/news"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1"
          >
            查看全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 hover:border-background-300 overflow-hidden transition-all duration-300"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500 text-background-50 rounded-full text-xs font-medium whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line text-xs"></i>
                    {article.viewCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}